export const MAX_SELECTED_SOFT_TAGS = 5;
